const {
  GET_ORDERS_ANALYTICS,
  GET_ORDERS_ANALYTICS_ERROR,
} = require('../actions/types');

const initialState = {
  data: null,
  loading: true,
  error: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ORDERS_ANALYTICS:
      return {
        ...state,
        data: payload,
        loading: false,
      };

    case GET_ORDERS_ANALYTICS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
